import { BrowserRouter } from 'react-router-dom';
import { ApiClient, ApiProvider } from 'jsonapi-react'
import ReactDOM from 'react-dom';
import Router from './router';
import './styles.sass';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'jquery';
import 'popper.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//TODO  Agregar url base desde archivo .env 
const client = new ApiClient({ url: 'https://app.capitalizarmerent.com/api/v1/' })

document.fonts.add(new FontFace("Helvetica Now Display", `url('https://cdn.homierent.com/strapi-media/Helvetica_Now_Display_Regular_3b0cc63188.otf')`));
document.fonts.add(new FontFace("Mabry Pro", `url('https://cdn.homierent.com/strapi-media/Mabry_Pro_Regular_cd37911871.otf')`));

ReactDOM.render(
  <BrowserRouter>
    <ApiProvider client={client}>
      <Router />
    </ApiProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
